import React from "react";

const BackIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8327 7.00033H1.16602M1.16602 7.00033L6.99935 12.8337M1.16602 7.00033L6.99935 1.16699"
      stroke="#1E1E1E"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ProfileHeader = ({ onBackClick, children }) => {
  return (
    <div className="w-full px-4 md:px-12 py-4 flex items-center justify-between border-b border-[#E5E6E8]">
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={onBackClick}
      >
        <BackIcon />
        <span className="text-xl font-bold text-[#222A35]">Back</span>
      </div>
      {children}
    </div>
  );
};

export default ProfileHeader;
